import { Russian } from "flatpickr/dist/l10n/ru.js";
import { Arabic } from "flatpickr/dist/l10n/ar";
import { Spanish } from "flatpickr/dist/l10n/es";
import { French } from "flatpickr/dist/l10n/fr";
import { Japanese } from "flatpickr/dist/l10n/ja";
import { Indonesian } from "flatpickr/dist/l10n/id";
import { Croatian } from "flatpickr/dist/l10n/hr";
import { Mandarin } from "flatpickr/dist/l10n/zh";
import { Swedish } from "flatpickr/dist/l10n/sv";
import { Hindi } from "flatpickr/dist/l10n/hi";
import { Romanian } from "flatpickr/dist/l10n/ro";
import { German } from "flatpickr/dist/l10n/de";

export const flatPickerLocale = {
    'es': Spanish,
    'fr-FR': French,
    'ru-RU': Russian,
    'ja-JP': Japanese,
    'id-ID': Indonesian,
    'hr-HR': Croatian,
    'zh-CN': Mandarin,
    'sv-SE': Swedish,
    'ar': Arabic,
    'hi-IN': Hindi,
    'ro-RO': Romanian,
    'de-DE': German
}